<template>
  <div class="Echarts">
    <div id="main"></div>
  </div>
</template>
 
<script>
import api from "@/api/home.js"
export default {
  name: 'Echarts',
  data(){
    return {
      edges:[],
      datas:[]
    }
  },
  methods: {
    randomHexColor(){//十六进制颜色随机
      //随机生成十六进制颜色 
      var hex = Math.floor(Math.random() * 16777216).toString(16);
      //生成ffffff以内16进制数 
      while (hex.length < 6) {
          //while循环判断hex位数，少于6位前面加0凑够6位
          hex = '0' + hex;
      }
      return '#' + hex;  //返回‘#'开头16进制颜色
    },
    getposition(){
      return Math.floor(Math.random()*100+1)
    },
    myEcharts(){
      var myChart = this.$echarts.init(document.getElementById('main'));
      let option ={
            // title: {
            //   // text: 'NPM Dependencies'
            // },
            animationDurationUpdate: 1500,
            animationEasingUpdate: 'quinticInOut',
            series: [
              {
                type: 'graph',
                layout: 'none',
                // progressiveThreshold: 700,
                data: this.datas,
                edges: this.edges,
                emphasis: {
                  focus: 'adjacency',
                  label: {
                    position: 'right',
                    show: true,
                    formatter: '{b}'
                  }
                },
                label: {
                  position: 'right',
                  show: true,
                  formatter: '{b}'
                },
                roam: true,
                lineStyle: {
                  width: 0.5,
                  curveness: 0.3,
                  opacity: 0.7
                }
              }
            ]
          }
      myChart.setOption(
          (option),
          true
        );
    },
    getDictItemListData(){
      api.getDictItemList({
        dictId:'1415574243599777794',field:'id,,itemText,itemValue,action',pageNo:1,pageSize:1000
      })
      .then((res)=>{
        if(res.code==0&&res.result.records.length>0){
          
          this.datas=res.result.records.map((item)=>{
            let colorinf=this.randomHexColor()
            return {
                    "name": item.itemText,
                    "y": this.getposition(),
                    "x": this.getposition(),
                    "id": item.itemText,
                    "symbolSize": 50,
                    itemStyle: {
                        color: colorinf
                      }
                  }
          })
        }
        //  console.log('this.datas',this.datas)
      }).catch((err) => {
          });
    },
    getkmKnowledgeMap(){
      api.getkmKnowledgeMap({
        pageNo:1,pageSize:1000
      })
      .then((res)=>{
        if(res.code==200&&res.result.records.length>0){

          this.edges=res.result.records.map((item)=>{
            return {
                    source: item.sourceItemText,
                    target: item.targetItemText
                  }
          })
        }
        // console.log('this.edges',this.edges)
      }).catch((err) => {
          });
    },
  },
  mounted(){
    this.getDictItemListData();
    this.getkmKnowledgeMap();
    setTimeout(()=>{

      this.myEcharts();
    },500)
  }
}
</script>
 
<style lang="less">
  .Echarts{
    padding: 40px 0;
    width: 100%;
    height: 100%;
    #main{
      width: 100%;
      height: 100%;
    }
  }
</style>